import React from "react";
import { Modal, Form, Button, Input, Select, Icon } from "antd";
import MaskedInput from "antd-mask-input";

import { CountryType, PostalCodePayloadType, PostalCodeType } from "../types";

interface PostalCodeState {
  mode: string;
  postalCodeName: string;
  postalCodeMask: string;
  postalCodeNameError: boolean;
  duplicatePostalCode: any;
}

interface PostalCodeProps {
  country: CountryType;
  postalCode: PostalCodeType;
  postalCodes: any;
  zipCodeOf: string;
  close: () => any;
  createPostalCode: (payload: PostalCodePayloadType, zipCodeOf: string) => any;
  updatePostalCode: (
    postalCodeID: number,
    payload: PostalCodePayloadType,
    zipCodeOf: string
  ) => any;
}

const formPopUpLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

function escapeRegExp(str: string) {
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function replaceAll(str: string, find: string, replace: string) {
  return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
}
const Mode = {
  ADD: "ADD",
  UPDATE: "UPDATE",
};
class PostalCode extends React.Component<PostalCodeProps, PostalCodeState> {
  constructor(props: PostalCodeProps) {
    super(props);
    const mode = !!props.postalCode ? Mode.UPDATE : Mode.ADD;
    const postalCodeName = !!props.postalCode
      ? props.postalCode.pcPostalcode
      : "";
    // original postalCode Mask provided by system
    const postalCode = props.country.coPostalcodeMask;
    // Below the given mask is converted to another format as used by library antd-mask-input
    // popular terminologies for zip code /postal code mask describes
    // Z as alphabet charactge
    // X as alpha numeric and
    // 9 as numeric
    // here in our case the respective mask formatter has A for alphabetic ( upper case ) representation,
    // # has alphanumeric ( upper case ) and 1 as numeric character
    let postalCodeMask = replaceAll(postalCode, "Z", "A"); // first pass replacing alphabetic mask
    postalCodeMask = replaceAll(postalCodeMask, "X", "#"); // second pass replacing alpha-numeric mask
    postalCodeMask = replaceAll(postalCodeMask, "9", "1"); // third pass replacing numeric mask, there goes our wonderful dynamic mask
    this.state = {
      postalCodeName,
      postalCodeNameError: false,
      postalCodeMask,
      mode,
      duplicatePostalCode: null,
    };
  }
  createPostalCode = () => {
    if (!this.isValidPostalCode()) return;
    const payload = {
      pcPostalcode: this.state.postalCodeName,
      pcCountryRef: this.props.country.coId,
    };
    this.props.createPostalCode(payload, this.props.zipCodeOf);
  };

  isValidPostalCode = () => {
    const duplicatePostalCodeValue = this.props.postalCodes.filter(
      (item) => item.pcPostalcode === this.state.postalCodeName
    );
    this.setState({ duplicatePostalCode: duplicatePostalCodeValue });
    let validPostalCode = true;
    const { postalCodeName } = this.state;
    if (
      postalCodeName === "" ||
      postalCodeName.indexOf("_") > -1 ||
      duplicatePostalCodeValue.length > 0
    ) {
      validPostalCode = false;
      this.setState({
        postalCodeNameError: true,
      });
    }
    return validPostalCode;
  };
  updatePostalCode = () => {
    if (!this.isValidPostalCode()) return;
    const postalCodeID = this.props.postalCode.pcId;
    const payload = {
      pcPostalcode: this.state.postalCodeName,
      pcCountryRef: this.props.country.coId,
    };
    this.props.updatePostalCode(postalCodeID, payload, this.props.zipCodeOf);
  };
  handlePostalCodeNameChange = (e) => {
    this.setState({
      postalCodeName: e.target.value,
      postalCodeNameError: false,
    });
  };
  render() {
    const { country } = this.props;
    const { mode } = this.state;
    return (
      <Modal
        title={`${mode === "ADD" ? "Create Postal Code" : "Edit Postal Code"}`}
        visible
        footer={null}
        onCancel={this.props.close}
        width={450}
        className='postal-code-modal'
      >
        <Form {...formPopUpLayout}>
          <Form.Item label='Country'>
            <Input readOnly value={country && country.coDescription} />
          </Form.Item>
          <Form.Item
            label='Postal Code'
            required
            validateStatus={this.state.postalCodeNameError ? "error" : ""}
            help={
              this.state.postalCodeNameError
                ? this.state.postalCodeName === ""
                  ? "Zip Code / Postal Code is required."
                  : this.state.duplicatePostalCode.length > 0
                  ? "Postal Code already exists."
                  : "Invalid postal code."
                : ""
            }
          >
            {this.state.postalCodeMask !== "" ? (
              <MaskedInput
                value={this.state.postalCodeName}
                maxLength={this.state.postalCodeMask.length}
                mask={this.state.postalCodeMask}
                name='postal-code'
                onChange={this.handlePostalCodeNameChange}
                placeholder='ZIP Code/Postal Code'
              />
            ) : (
              <Input
                value={this.state.postalCodeName}
                name='postal-code'
                onChange={this.handlePostalCodeNameChange}
                placeholder='ZIP Code/Postal Code'
                maxLength={10}
              />
            )}
          </Form.Item>
        </Form>
        <div className='actions'>
          <Button onClick={this.props.close}>Close</Button>
          <Button
            onClick={
              mode === Mode.ADD ? this.createPostalCode : this.updatePostalCode
            }
            type='primary'
          >
            {mode === Mode.ADD ? "Add" : "Update"}
          </Button>
        </div>
      </Modal>
    );
  }
}

export default PostalCode;
